import baseApi from "@/lib/redux/api/baseApi";

export const customerFormApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // Get all sesssion by date wise
    getSessionsByDate: builder.mutation({
      query: ({ userId, date, day, formId }) => ({
        url: `/form/view/next/session/list/${userId}`,
        method: "POST",
        body: {
          bookingDate: date,
          weekday: day,
          form_guid: formId,
        },
      }),
      providesTags: ["Customer Form"],
    }),

    // Get all forms for a user
    getForm: builder.query({
      query: (formId) => ({
        url: `/form/view/${formId}`,
        method: "GET",
      }),
      providesTags: ["Customer Form"],
    }),
    saveForm: builder.mutation({
      query: (clientData) => ({
        url: "/form_answer/save",
        method: "POST",
        body: clientData,
      }),
      providesTags: ["Customer Form"],
    }),
    // Session Listing
    getSessionListing: builder.query({
      query: (userId) => ({
        url: `/interested_in/view/list/${userId}`,
        method: "GET",
      }),
      providesTags: ["Forms"],
    }),
  }),
  overrideExisting: true,
});

export const {
  useGetSessionsByDateMutation,
  useGetFormQuery,
  useSaveFormMutation,
  useGetSessionListingQuery,
} = customerFormApi;
